var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHubspotLogo32X32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 29.6098,
    height: 30,
    rx: 4,
    fill: "#FF7A59"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_264_24810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8406 13.2965V11.4355C20.3414 11.2036 20.663 10.6975 20.6683 10.144V10.1018C20.6683 9.31101 20.0251 8.66786 19.2344 8.66786H19.1922C18.4014 8.66786 17.7583 9.31101 17.7583 10.1018V10.144C17.7583 10.6975 18.0798 11.1983 18.5859 11.4355V13.2965C17.8795 13.4072 17.2153 13.6971 16.6564 14.1452L11.5586 10.1756C11.5955 10.0438 11.6166 9.90673 11.6166 9.77493C11.6166 8.884 10.8997 8.16177 10.0087 8.15649C9.1178 8.15649 8.39556 8.87346 8.39029 9.76439C8.38502 10.6553 9.10725 11.3776 9.99818 11.3828C10.2776 11.3828 10.5517 11.309 10.7942 11.1667L15.8182 15.0731C14.8957 16.4701 14.922 18.2836 15.8815 19.6542L14.3527 21.1831C14.2314 21.1462 14.0996 21.1251 13.9731 21.1198C13.2403 21.1198 12.6499 21.7155 12.6499 22.443C12.6499 23.1758 13.2456 23.7662 13.9731 23.7662C14.7059 23.7662 15.2963 23.1758 15.2963 22.443C15.2963 22.3113 15.2753 22.1847 15.2331 22.0635L16.7461 20.5505C18.5279 21.9211 21.0847 21.589 22.4607 19.8071C23.8314 18.0253 23.4992 15.4684 21.7174 14.0925C21.1638 13.6761 20.5207 13.4019 19.8406 13.2965ZM19.2132 19.4117C18.0587 19.4434 17.0993 18.5314 17.0676 17.3821C17.036 16.2276 17.948 15.2681 19.0973 15.2365C19.1342 15.2365 19.1764 15.2365 19.2132 15.2365C20.3678 15.2787 21.2692 16.2434 21.2271 17.3979C21.1902 18.4892 20.3098 19.3696 19.2132 19.4117Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 29.6098,
    height: 30,
    rx: 4,
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_264_24810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.6098,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspotLogo32X32);
export default __webpack_public_path__ + "static/media/Hubspot-Logo-32x32.572fa9c4.svg";
export { ForwardRef as ReactComponent };